(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dji-product-icons"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionEl = document.getElementById('section-{{ section.id }}');
  if (!sectionEl) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const strips = sectionEl.querySelectorAll('[data-product-strip]');
  if (!strips.length) return;

  const initStrip = (strip) => {
    const viewport = strip.querySelector('[data-strip-viewport]');
    const prev = strip.querySelector('[data-strip-prev]');
    const next = strip.querySelector('[data-strip-next]');
    if (!viewport || !prev || !next) return;

    const getScrollAmount = () => Math.max(viewport.clientWidth * 0.8, 160);

    const updateState = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const hasOverflow = maxScroll > 0.5;
      strip.classList.toggle('rp-product-strip--has-overflow', hasOverflow);
      prev.disabled = !hasOverflow || viewport.scrollLeft <= 2;
      next.disabled = !hasOverflow || viewport.scrollLeft >= maxScroll - 2;
    };

    const scrollOptions = () => ({
      left: getScrollAmount(),
      behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
    });

    next.addEventListener('click', () => {
      viewport.scrollBy(scrollOptions());
    });

    prev.addEventListener('click', () => {
      const options = scrollOptions();
      options.left = options.left * -1;
      viewport.scrollBy(options);
    });

    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateState();
        ticking = false;
      });
    };

    viewport.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateState);

    const setCardHover = (card, force) => {
      if (!card) return;
      card.classList.toggle('is-hovered', force);
    };

    strip.querySelectorAll('.rp-product-strip__card').forEach((card) => {
      card.addEventListener('mouseenter', () => setCardHover(card, true));
      card.addEventListener('mouseleave', () => setCardHover(card, false));
      card.addEventListener('focusin', () => setCardHover(card, true));
      card.addEventListener('focusout', () => setCardHover(card, false));
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateState);
      observer.observe(viewport);
    }

    viewport.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', updateState, { once: true });
    });

    updateState();
  };

  strips.forEach(initStrip);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dji-whats-hot"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionEl = document.getElementById('section-{{ section.id }}');
  if (!sectionEl) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const strips = sectionEl.querySelectorAll('[data-hot-strip]');
  if (!strips.length) return;

  const initStrip = (strip) => {
    const viewport = strip.querySelector('[data-hot-viewport]');
    const prev = strip.querySelector('[data-hot-prev]');
    const next = strip.querySelector('[data-hot-next]');
    const list = strip.querySelector('.rp-hot__list');
    if (!viewport || !prev || !next || !list) return;

    const getGap = () => {
      const styles = window.getComputedStyle(list);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return isNaN(gap) ? 0 : gap;
    };

    const getCardWidth = () => {
      const firstItem = list.querySelector('.rp-hot__item');
      if (!firstItem) return viewport.clientWidth;
      return firstItem.getBoundingClientRect().width;
    };

    const getScrollAmount = () => getCardWidth() + getGap();

    const updateState = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const hasOverflow = maxScroll > 0.5;
      strip.classList.toggle('rp-hot--has-overflow', hasOverflow);
      prev.disabled = !hasOverflow || viewport.scrollLeft <= 2;
      next.disabled = !hasOverflow || viewport.scrollLeft >= maxScroll - 2;
    };

    const scrollOptions = (direction = 1) => ({
      left: getScrollAmount() * direction,
      behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
    });

    next.addEventListener('click', () => {
      viewport.scrollBy(scrollOptions(1));
    });

    prev.addEventListener('click', () => {
      viewport.scrollBy(scrollOptions(-1));
    });

    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateState();
        ticking = false;
      });
    };

    viewport.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateState);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateState);
      observer.observe(viewport);
    }

    viewport.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', updateState, { once: true });
    });

    updateState();
  };

  strips.forEach(initStrip);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-fixed"]) return;
  try {
    
  function initPromoFixed(){
    var $ttpromofixed = $(".tt-promo-fixed"),
    	$promofixeddata = $(".promofixeddata"),
        $promofixedclose = $ttpromofixed.find(".tt-btn-close");
    
    if($('html').hasClass('touch-device') && $ttpromofixed.hasClass('hidden-mobile')) return false;
	if($ttpromofixed.hasClass('hidden-mobile') && $(window).width < 1025) return false;
    if($promofixeddata.length == 0) return false;
    
    setPromoFixedItem($ttpromofixed, $promofixeddata);
	showPromoFixed($ttpromofixed, $ttpromofixed.data('start'));
    
	showPromoFixedNextMessage($ttpromofixed, $promofixeddata, $promofixedclose)

    $promofixedclose.click(function(){
      $ttpromofixed.addClass('nonevent').fadeTo(100, 0);
    });
  }
  function showPromoFixedNextMessage($modal, $data, $close){
    var nextmin = $modal.data('min'),
        nextmax = $modal.data('max');
	var i = getRndInteger(nextmin, nextmax);
    setTimeout(function(){
      $close.trigger('click');
      setTimeout(function(){
        setPromoFixedItem($modal, $data);
        showPromoFixed($modal, 0);
        showPromoFixedNextMessage($modal, $data, $close);
      }, 100);
    }, i);
  }
  function getPromoFixedCustomProductIndex($promofixeddata){
    var min = 0,
        max = $promofixeddata.children().length;
    return getRndInteger(min, max);
  }
  function setPromoFixedItem($modal, $data){
    var i = getPromoFixedCustomProductIndex($data)
    var data = $data.children().eq(i);
    $modal.find('.tt-img').find('a').attr('href', data.data('url')).find('img').attr('src', data.data('image')).attr('alt', data.data('alt'));
    $modal.find('.pr_name').attr('href', data.data('url')).text(data.data('name'));
    
    var nummin = parseInt(data.data('min')),
    	nummax = parseInt(data.data('max')),
    	num = getRndInteger(nummin, nummax);
    $modal.find('.tt-info-value').text(num);

	if (typeof data.data('text') === typeof undefined) return false;
    var str = data.data('text').split('||'),
    	i = getRndInteger(0, str.length-1);
    $modal.find('.tt-info-text').text(str[i]);
  }
  function showPromoFixed($parent, delay){
    setTimeout(function(){
	  $parent.removeClass('nonevent').fadeTo(300, 1);
    }, delay);
  }
  function getRndInteger(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  }
  setTimeout(initPromoFixed, 300);

  } catch(e) { console.error(e); }
})();
})();
